var _desc, _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPracticesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "mynaui:activity",
    rx: 7.5,
    width: 45,
    height: 45,
    transform: "translate(0.500000 0.500000)",
    fill: "#F7F8F8",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 23L29.03 23C28.82 23 28.72 23 28.63 23.04C28.55 23.08 28.48 23.14 28.43 23.21C28.37 23.3 28.34 23.41 28.27 23.65L26.46 30.5C26.22 31.37 26.11 31.81 25.93 31.92C25.86 31.97 25.77 32 25.69 32C25.6 31.99 25.52 31.97 25.45 31.92C25.27 31.8 25.16 31.37 24.93 30.49L21.06 15.5C20.83 14.62 20.72 14.18 20.54 14.07C20.47 14.02 20.39 14 20.3 14C20.22 14 20.13 14.02 20.06 14.07C19.88 14.18 19.77 14.62 19.54 15.49L17.72 22.34C17.66 22.58 17.62 22.69 17.56 22.78C17.51 22.85 17.44 22.91 17.36 22.95C17.27 23 17.17 23 16.96 23L14 23",
    stroke: "#7252DC",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticesIcon);
export default __webpack_public_path__ + "static/media/practicesIcon.976bf26e0107fef03afb1e029a91ef5b.svg";
export { ForwardRef as ReactComponent };